/* eslint-disable react-hooks/exhaustive-deps */
// React
import { useEffect, useState } from "react";

// Redux
import { useDispatch } from "react-redux";

import { getSpecificUser } from "../../../redux/features/Settings/Management/Users";

// Components
import SourceDestinationAccountDetail from "../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";

import ICONS from "../../../assets/Icons";
import { viewAccountDetailR } from "../../../redux/features/accounts/ReimburseAccount";
import CommonLayout from "../../_utils/CommonLayout";
import Loader from "../../Loader/Index";
import "./index.css";

const ReimbursementRequestAccount = (props) => {
  //  useNavigate, useDispatch
  const dispatch = useDispatch();

  //  useState
  const [loading, setLoading] = useState(
    // false,
    props?.txnPayLoad?.beneAccountId?.length ? false : true,
  );

  const [isError, setIsError] = useState(false);
  const [isArchive, setIsArchive] = useState(false);

  //  Callbacks
  const fetch = async () => {
    setLoading(true);
    if (!props?.txnPayLoad?.beneAccountId?.length) {
      const id = JSON.parse(sessionStorage.getItem("response"))?.employees?.id;
      let response = await dispatch(getSpecificUser(id));

      if (
        response?.payload?.employees?.[0]?.register_accounts
          ?.reimbursement_accounts?.beneficiary_account_id
      ) {
        let data = await dispatch(
          viewAccountDetailR({
            id: response?.payload?.employees?.[0]?.register_accounts
              ?.reimbursement_accounts?.beneficiary_account_id,
          }),
        );
        if (data?.payload?.reimbursement_accounts?.[0]?.archived === "Y") {
          setIsArchive(true);
        }
        handleAccountSelection(
          data?.payload?.reimbursement_accounts?.[0]?.name,
          data?.payload?.reimbursement_accounts?.[0]?.bank_acc_no,
          data?.payload?.reimbursement_accounts?.[0]?.ifsc_code,
          data?.payload?.reimbursement_accounts?.[0]?.ifsc_code,
          data?.payload?.reimbursement_accounts?.[0]?.category_ids
            ?.map((x) => x.category_name)
            ?.join(","),
          data?.payload?.reimbursement_accounts?.[0]?.category_ids?.map(
            (x) => x.category_id,
          ),
          data?.payload?.reimbursement_accounts?.[0]?.pan_no,
          data?.payload?.reimbursement_accounts?.[0]?.id,
          data?.payload?.reimbursement_accounts?.[0]?.labels,
        );

        setLoading(false);
      } else {
        setIsError(true);
        setLoading(false);
      }
    }
    setLoading(false);
  };

  //  useEffect
  useEffect(() => {
    fetch();
  }, []);

  const handleCloseModal = () => {
    props?.setIsModalOpen(false);
  };

  const handleAccountSelection = (
    accountName,
    accountNumber,
    ifsc,
    bankLogo,
    category,
    categoryIds,
    panNo,
    beneAccountId,
    labels,
  ) => {
    // setAccountName(accountName);
    // setBankLogo(bankLogo);
    // setPanNumber(panNo);
    props?.setLabelsAcc(labels);

    props?.setTxnPayLoad((prev) => ({
      ...prev,
      bankAccountName: accountName,
      beneAccountId: beneAccountId,
      bankAccountIFSC: ifsc,
      bankAccountNo: accountNumber,
      bankLogo: bankLogo,
      pan: panNo,
      labels: labels,
      mergeCategory: null,
    }));
    props?.setAmountInWords("");
    props?.setCategoryIds(categoryIds);
    handleCloseModal();
  };

  return (
    <>
      <div
        className={`max-w-tab-width-normal mx-auto w-width-full Qlg:px-padding-base px-padding-md Qsmd:pt-padding-lg py-padding-md ${loading ? "h-full" : "h-auto"}`}
      >
        {loading ? (
          <>
            <div className="w-full h-full flex-1 flex items-center justify-center">
              <Loader />
            </div>
          </>
        ) : (
          <CommonLayout>
            <div
              className={`w-width-full lg:max-w-[var(--create-box-width)] items-stretch `}
            >
              {isError ? (
                <div className="p-padding-md flex items-center bg-emphasis rounded-border-radius-md mb-margin-md">
                  <div className="flex items-center gap-x-gap-sm">
                    <img
                      className="h-icon-md w-icon-md flex-shrink-0"
                      src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
                      alt="error"
                    />
                    <p className="text-text-primary text-font-sm font-normal">
                      No reimbursement account is linked to your user. Link an
                      account to create a request.
                    </p>
                  </div>
                </div>
              ) : isArchive ? (
                <div className="p-padding-md flex items-center bg-emphasis rounded-border-radius-md mb-margin-md">
                  <div className="flex items-center gap-x-gap-sm">
                    <img
                      className="h-icon-md w-icon-md flex-shrink-0"
                      src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
                      alt="error"
                    />
                    <p className="text-text-primary text-font-sm font-normal">
                      The linked account is archived. Contact the admin to
                      unarchive the account.
                    </p>
                  </div>
                </div>
              ) : null}
              <SourceDestinationAccountDetail
                type="destination"
                flow="beneficiary"
                modalOpen={props?.isModalOpen}
                setModalOpen={props?.setIsModalOpen}
                txnPayLoad={props.txnPayLoad}
                setTxnPayLoad={props.setTxnPayLoad}
                shouldShowAssociatedAccounts={false}
                handleOnAccountSelection={handleAccountSelection}
                isDisabled={isError || isArchive ? true : false}
                isEditDisabled={true}
                isReimbursement={true}
                page="confirm"
              />
            </div>
          </CommonLayout>
        )}

        <div className="h-mobile-create-header w-width-full Qmd:hidden block mt-margin-md"></div>
      </div>
    </>
  );
};

export default ReimbursementRequestAccount;
